export const createEventModel = {
	title: "",
	participants: [],
	allDay: false,
	startTime: "",
	endTime: "",
	recurring: false,
	// meetingLink: "",
	otherDetails: "",
};
